module.exports = __webpack_public_path__ + "img/modular01_active.2a188e87.png";